import React, { useState } from "react";
import Switch from "react-switch";
import styles from "./Post.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const EnablePollContainer = ({ enablePoll, setEnablePoll, pollOption, setPollOption, customPoll, setCustomPoll, showResults, setShowResults, fileData, allState, isPollLocked }) => {
	const navigate = useNavigate();
	const { pollObj } = useSelector((state) => state.temp);
	return (
		<>
			<div className={styles.EnablePollContainer}>
				<div className={styles.left}>
					{/* {customPoll && pollObj.pollKeys.length > 0 ? (
						pollObj.pollKeys.map((key, i) => (
							<button key={i} className={styles.active}>
								{String.fromCharCode(65 + i)}. {key}
							</button>
						))
					) : ( */}
						<>
							<button
								className={`${styles.pollChoiceButton} ${pollOption === "yes" ? styles.active : ""} ${isPollLocked ? styles.pollChoiceDisabled : ""}`}
								onClick={() => {
									if (isPollLocked) {
										toast.info("Please Enable Poll !");
										return;
									}
									setPollOption("yes");
								}}
							>
								A. Yes
							</button>

							<button
								className={`${styles.pollChoiceButton} ${pollOption === "no" ? styles.active : ""} ${isPollLocked ? styles.pollChoiceDisabled : ""}`}
								onClick={() => {
									if (isPollLocked) {
										toast.info("Please Enable Poll !");
										return;
									}
									setPollOption("no");
								}}
							>
								B. No
							</button>
						</>
					{/* )} */}
				</div>

				<div className={styles.right} style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
					<p style={{ fontSize: "1.8rem", fontWeight: "400", margin: 0, marginRight: "1rem" }}>Enable Poll</p>
					<Switch
						onChange={(e) => setEnablePoll(e)}
						checked={enablePoll}
						offColor={"#F3DFF3"}
						onColor={"#F3DFF3"}
						onHandleColor="#A6539D"
						offHandleColor="#A6539D"
						height={20}
						width={44}
					/>
				</div>
			</div>
			<div className={styles.PollSettings} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
				{enablePoll && (
					<>
						<div className={styles.toggleRow} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<h2 style={{ fontWeight: "400", fontSize: "1.6rem" }}>Custom Poll</h2>
							<Switch
								checked={customPoll}
								onChange={(e) => {
									setCustomPoll(e);

									if (e) {
										navigate("/customPoll", {
											state: {
												fileData,
												...allState,
												enablePoll: true,
												customPoll: true
											}
										});
									}
								}}
								offColor={"#EEEEEE"}
								onColor={"#F3DFF3"}
								onHandleColor="#A6539D"
								offHandleColor="#A6539D"
								height={20}
								width={44}
							/>
						</div>

						<div className={styles.toggleRow} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<h2 style={{ fontWeight: "400", fontSize: "1.6rem" }}>Show Results to audience</h2>
							<Switch
								checked={showResults}
								onChange={setShowResults}
								offColor={"#EEEEEE"}
								onColor={"#F3DFF3"}
								onHandleColor="#A6539D"
								offHandleColor="#A6539D"
								height={20}
								width={44}
							/>
						</div>
					</>
				)}
			</div>
		</>
	);
};

export default EnablePollContainer;


